<template>
  <div id="app">
  
    <!-- Header -->
    <header id="header" role="header">
      <!-- Notice Banner
        <div v-if="$route.name != 'Teacher'" class="sticky-nav notice-banner position-relative d-flex justify-content-center align-items-center pl-5 pr-2 px-lg-5 py-2">
          <p class="guide-text2" v-if="$i18n.locale == 'en'">
            Tell us how you could Be Canada’s Next Upstander! <a href="https://humanrights.ca/education/be-canadas-next-upstander">Enter our contest</a> to win a trip to the Canadian Museum for Human Rights.
          </p>
          <p class="guide-text2" v-else>
            Dis-nous comment tu es un défenseur ou une défenseure en herbe! <a href="https://droitsdelapersonne.ca/education/defenseure-en-herbe">Participe à notre concours</a> pour courir la chance de gagner un voyage au Musée canadien pour les droits de la personne.
          </p>
        </div>
      -->
        <div class="position-relative">
          <div class="sticky-nav links d-flex justify-content-end align-items-center w-100 position-absolute px-5">
            <div class="d-none d-md-block">
              <a href="#" v-on:click.prevent="switchLang('en')" :class="{'current': $i18n.locale == 'en'}">English</a>
              <a href="#" v-on:click.prevent="switchLang('fr')" :class="{'current': $i18n.locale == 'fr'}">Français</a>
              <span class="vert-divider mr-2"></span>
              <a v-if="$route.name == 'Teacher'" href="#/">{{ $t(iKey('ui_labels','ui','student_view')) }}</a>
              <a v-else :href="$i18n.locale == 'en' ? '#/teacher-guide' : '#/guide-pédagogique'">{{ $t(iKey('ui_labels','ui','teacher_guide')) }}</a>
            </div>
          </div>
          <div v-if="$route.name != 'Teacher'" class="sticky-nav d-flex justify-content-center justify-content-sm-start ml-lg-5 pl-lg-5 pl-xl-1 align-items-center w-100 position-absolute">
            <div class="logo">
              <SVGLogoEn v-if="$i18n.locale == 'en'"></SVGLogoEn>
              <SVGLogoFr v-else></SVGLogoFr>
            </div>
          </div>
        </div>
    </header>  
    
    <div v-if="$route.name != 'Teacher'">
    <SideMenu v-if="items.related_menu_items" :items="items.related_menu_items"></SideMenu>
    </div>

    <!-- Main Content Area -->
    <main role="main">
    <router-view></router-view>
    </main>

    

    <!-- Footer -->
    <footer id="footer" role="contentinfo" class="pb-4">

      <!-- Notice -->  
      <div v-if="$t(iKey('footer_section', 'notice', 'text'))" class="feedback-box">
      <div class="container pt-5 pb-4">
        <div class="row">
          <div class="col-12 text" v-html="$t(iKey('footer_section', 'notice', 'text'))"></div>
        </div>
      </div>
    </div>

      <div class="container">
        <div class="row pt-5 pb-3">
          <div class="col-lg-8">
            <div class="logo mb-5 mt-1">
            <SVGLogoEn v-if="$i18n.locale == 'en'"></SVGLogoEn>
            <SVGLogoFr v-else></SVGLogoFr>
            </div>
          </div>
          <div class="col-lg-4">
            <div v-if="items">
              <h2 class="h4 explainer2">{{ $t(iKey('footer_section', 'site_links', 'header')) }}</h2>
              <hr aria-hidden="true" class="">
              <ul v-if="items.footer_section" class="list-unstyled" role="navigation">
                <li v-for="(l, index) in items.footer_section[0].value.site_links" :key="index">
                    <a :href="$t(iKey('footer_section', 'site_link', 'url_' + index))">{{ $t(iKey('footer_section', 'site_link', 'label_' + index)) }} <SVGArrowLink aria-hidden="true" class="ml-1"></SVGArrowLink></a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row">
          <div v-if="items" class="col-12 d-flex footer-base-links align-items-center">
              <span v-if="items.footer_section" class="list-unstyled" role="navigation">
                <a v-for="(l, index) in items.footer_section[0].value.legal_links" 
                  :key="index" 
                  :href="$t(iKey('footer_section', 'legal_link', 'url_' + index))">
                   {{ $t(iKey('footer_section', 'legal_link', 'label_' + index)) }}
                <SVGArrowLink aria-hidden="true" class="ml-1"></SVGArrowLink></a>
              </span>
          </div>
        </div>

        <div class="row justify-content-center pt-5 pt-lg-4 pb-5 copyright">
          <div>{{ $t(iKey('footer_section', 'copyright', 'text'))}}</div>
        </div>

      </div>
    </footer>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import SVGLogoEn from '@/assets/icons/cmhr-logo-en.svg'
import SVGLogoFr from '@/assets/icons/cmhr-logo-fr.svg'
import SVGArrowLink from '@/assets/icons/arrow-link.svg'
import SideMenu from '@/components/menu/SideMenu.vue'

export default {
  name: 'app',
  components: {
    SVGLogoEn,
    SVGLogoFr,
    SVGArrowLink,
    SideMenu
  },
  methods: {
    
    // scrollFix(hashbang){
    //   console.log('hash: ', hashbang)
    //   //location.href = hashbang;
    //   window.location.hash = '#' + hashbang;
    // }
  },
  computed: {
    ...mapState('page', ['items']),
  },
  mounted() {
    this.$store.dispatch('page/GET_ITEMS')
    this.$i18n.locale = 'en'
    //setTimeout(() => this.scrollFix(this.$route.hash), 10)
    if(window.location.hostname.indexOf('droitsdelapersonne') > -1){
      this.switchLang('fr')
    } else {
      this.switchLang('en')
    }

    var dur = this.windowHeight * 2
    const scene = this.$scrollmagic.scene({
          triggerElement: '#app',
          triggerHook: 0,
          duration: dur
      })
      this.$scrollmagic.addScene(
      scene
          .setClassToggle('#header', 'in')
          //.addIndicators()
      )
  }
}
</script>

<style scoped>
  
  #header {
    width: 100vw;
    z-index: 1000;
    position: fixed;
    opacity: 0.0;
    transition: opacity 0.4s ease-in-out;
    pointer-events: none;

    /* top position for when there is no announcement banner */
    /* top: 30px; */
  }
  #header.in {
    opacity: 1.0;
    pointer-events: auto;
  }
  #header .notice-banner {
    background-color: #6868c8;
    height: auto;
    min-height: 40px;
    width: 100%;
  }
  #header .notice-banner p,
  #header .notice-banner a {
    color: white;
    margin: auto;
    font-family: 'Lekton', sans-serif;
    font-size: 15px;
  }
  #header .notice-banner a:hover {
    text-decoration: underline;
  }
  @media (max-width: 992px) { 
    #header .notice-banner {
      min-height: 64px;
    }
    #header .notice-banner .guide-text2 a,
    #header .notice-banner .guide-text2 {
      line-height: 16px;
      margin-left: 0;
      font-size: 12px;
    }
  }
  @media (max-height: 480px) and (orientation: landscape) { 
    #header .notice-banner {
      display: none !important;
    }
    #header {
      top: -20px;
    }
  }
    .sticky-nav {
    height: 100px;
  }
  .sticky-nav.links {
    z-index: 1;
  }
  .sticky-nav a {
    font-family: 'UniversLTPro-55Roman';
    color: white;
    margin-right: 15px;
    display: inline-block;
  }
  .sticky-nav a.current {
    text-decoration: underline;
  }
  .logo {
    width: 180px;
    transition: width 0.3s;
  }
  @media (min-width: 578px) { 
    .logo {
      margin-left: 70px;
    }
  }
  .logo svg .st0 {
    fill: white;
  }
  @media (min-width: 992px) { 
    .logo {
        width: 240px;
    }
  }
  @media (min-width: 1367px) { 
    .logo {
        width: 280px;
        margin-left: 0px;
    }
  }
  @media (min-height: 480px) and (max-height: 640px) {
    #header .sticky-nav:not(.notice-banner) {
      top: -20px;
    }
  }
  .vert-divider {
    border-left: 1px solid white;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
  }

  .feedback-box {
    background-color: #ffd93d;
    color: black;
  }

  #footer {
    background-color: #232323;
    color: white;
  }
  #footer a {
    color: white;
  }
  #footer .logo {
    width: 180px;
    margin-left: 0;
  }
  @media (min-width: 992px) {
    #footer .logo {
      width: 180px;
    } 
  }
  #footer hr {
    border-color: white;
    opacity: 0.5;
  }
  
  .footer-base-links a {
    display: inline-block;
    margin-right: 30px;
    color: white;
  }
  .trip-advisor-logo {
    width: 65px;
  }
  .copyright {
    opacity: 0.5;
  }
</style>

<style>
  .feedback-box .text p {
    font-family: 'Lekton', sans-serif;
  }
</style>